export const ROLE_TYPE = {
  APPLICANT: '1',
  DEPENDENT: '2',
  LOAN_WRITER: '9',
  RISK_WRITER: '19',
};

export const CLIENT_ROLE_TYPE = {
  ADULT: 'Adult',
  CHILD: 'Child',
  OTHER: 'Other',
  GUARANTOR: 'Guarantor',
  POLICY_OWNER: 'Policy Owner',
};

export const CLIENT_ROLE_ID = {
  1: 'Adult',
};
